import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getCompanyDetail, companyList } from "../../api/company";
const initialState = {
  list: [],
  total: 0,
  details: {},
};

export const CompanySlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    list: (state, action) => {
      state.list = action.payload;
    },
    detail: (state, action) => {
      state.details = action.payload;
    },
    totalCount: (state, action) => {
      state.total = action.payload;
    },
  },
});

export const FetchCompanyList = createAsyncThunk(
  "FetchCompanyList",
  async (obj, { dispatch }) => {
    try {
      const response = await companyList(obj);
      if (response?.code === 1) {
        dispatch(list(response?.data?.company_list));
        dispatch(totalCount(response?.data?.total_company));
      }
      return response;
    } catch (error) {
      toast.error(error.message, {  autoClose: false,  closeButton: true});
    }
  }
);

export const FetchCompanyDetail = createAsyncThunk(
  "getCompanyDetail",
  async (obj, { dispatch }) => {
    const response = await getCompanyDetail(obj);
    if (response?.code === 1) {
      console.log(response, "Company details");
      dispatch(detail(response?.data?.company_details));
    }
    return response;
  }
);

export const { list, detail, totalCount } = CompanySlice.actions;

export default CompanySlice.reducer;
